import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  useChangeStatusMutation,
  useDeleteTaskMutation,
} from '../features/tasks/tasksApi';

import DeleteIcon from './DeleteIcon';
import EditIcon from './EditIcon';

const TaskAction = ({ status, id }) => {
  const [changeStatus] = useChangeStatusMutation();
  const [deleteTask] = useDeleteTaskMutation();
  const navigate = useNavigate();

  return (
    <>
      {status === 'completed' ? (
        <button className="lws-delete" onClick={() => deleteTask(id)}>
          <DeleteIcon />
        </button>
      ) : (
        <button className="lws-edit" onClick={() => navigate(`/edit/${id}`)}>
          <EditIcon />
        </button>
      )}
      <select
        className="lws-status"
        value={status || 'pending'}
        onChange={(e) => {
          changeStatus({ id, data: { status: e.target.value } });
        }}
      >
        <option value="pending">Pending</option>
        <option value="inProgress">In Progress</option>
        <option value="completed">Completed</option>
      </select>
    </>
  );
};

export default TaskAction;
